'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../Icon/Icon.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-list-item',
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnWrapper = "".concat(CLASSNAME, "__wrapper"),
    cnDealerName = "".concat(CLASSNAME, "__dealer-name"),
    cnDealerAddress = "".concat(CLASSNAME, "__dealer-address"),
    cnDealerZip = "".concat(CLASSNAME, "__dealer-zip"),
    cnDealerDistance = "".concat(CLASSNAME, "__dealer-distance");
/**
 * 
 */

var ListItem = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(ListItem, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(ListItem);

  function ListItem() {
    _rollupPluginBabelHelpers.classCallCheck(this, ListItem);

    return _super.apply(this, arguments);
  }

  _rollupPluginBabelHelpers.createClass(ListItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dealerDistance = _this$props.dealerDistance,
          dealerName = _this$props.dealerName,
          dealerAddress = _this$props.dealerAddress,
          dealerZip = _this$props.dealerZip,
          tagName = _this$props.tagName,
          type = _this$props.type,
          className = _this$props.className,
          onClick = _this$props.onClick,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseLeave = _this$props.onMouseLeave;
      var Tag = tagName;
      return /*#__PURE__*/React__default.createElement(Tag, {
        className: classNames(CLASSNAME, className, _rollupPluginBabelHelpers.defineProperty({}, "".concat(CLASSNAME, "--").concat(type), type)),
        onClick: onClick,
        onMouseLeave: onMouseLeave,
        onMouseEnter: onMouseEnter
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapper
      }, /*#__PURE__*/React__default.createElement("span", {
        className: cnDealerDistance
      }, dealerDistance), /*#__PURE__*/React__default.createElement("span", {
        className: cnDealerName
      }, /*#__PURE__*/React__default.createElement(Icon, {
        id: "pin-filled",
        size: "xs",
        className: cnIcon
      }), dealerName), dealerAddress && /*#__PURE__*/React__default.createElement("span", {
        className: cnDealerAddress
      }, dealerAddress), dealerZip && /*#__PURE__*/React__default.createElement("span", {
        className: cnDealerZip
      }, dealerZip)));
    }
  }]);

  return ListItem;
}(React__default.Component);
ListItem.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Address of dealer */
  dealerAddress: PropTypes.string,

  /** Distance to own Location */
  dealerDistance: PropTypes.string,

  /** Name of Dealer */
  dealerName: PropTypes.string,

  /** ZIP of dealer */
  dealerZip: PropTypes.string,

  /** On click callback */
  onClick: PropTypes.func,

  /** MouseEnter event */
  onMouseEnter: PropTypes.func,

  /** MouseLeave event */
  onMouseLeave: PropTypes.func,

  /** Tag Name */
  tagName: PropTypes.string,

  /** type of list item as modifier */
  type: PropTypes.string
};
ListItem.defaultProps = {
  onClick: function onClick() {
    return void 0;
  },
  onMouseEnter: function onMouseEnter() {
    return void 0;
  },
  onMouseLeave: function onMouseLeave() {
    return void 0;
  },
  tagName: 'li'
};

module.exports = ListItem;
